import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c(VRow,{attrs:{"justify":"center"}},[_c('div',[_c('br'),_c(VCard,{attrs:{"elevation":"0"}},[_c('div',{staticStyle:{"line-height":"2em"}},[_c('br')]),_c('v-card-content',[_c('LoginForm')],1)],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }